/**
 * @voltxampere/ui — RS-232 null-modem cable variant (Sprint 49-7)
 *
 * Crossover (null-modem) DB9-DB9 cable used to connect two DTE
 * devices (PC ↔ PC, PC ↔ embedded board). Wiring:
 *
 *   Pin 2 (RXD) ↔ Pin 3 (TXD)  crossed
 *   Pin 3 (TXD) ↔ Pin 2 (RXD)  crossed
 *   Pin 5 (GND) ↔ Pin 5 (GND)  straight
 *   Pin 7 (RTS) ↔ Pin 8 (CTS)  crossed (handshake loopback)
 *   Pin 4 (DTR) ↔ Pin 6 (DSR)  crossed
 *   Pin 1 (DCD) ↔ Pin 4 (DTR)  loopback for legacy modems
 *
 * Reference: Wikipedia "Null modem" article (cabling conventions).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (passive cable; no MNA contribution).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connectorRs232Cable = {
    id: "rs232-cable",
    nameTr: "RS-232 Null-Modem Kablo",
    nameEn: "RS-232 Null-Modem Cable",
    shortcut: "J",
    category: "connector",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "J",
    defaultValue: "RS232-X",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        busType: "rs232-cable",
        cableType: "null-modem",
        pinCount: 7, // typical reduced null-modem
        crossWiring: ["2-3", "3-2", "7-8", "8-7", "4-6", "6-4"],
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-rs232-cable.js.map